import React from 'react'
import logo from '../../Icons/softwaredevelopment.jpeg';
import AnimateOnScroll from '../../components/AnimateOnScroll';
import Padding from '../Padding';
import NavBar from '../NavBar';
import SEO from '../../components/SEO'
import Sales from '../Sales';

class DatabaseLIMS extends React.Component {
    render() {
      return (

      <div id='DatabaseLIMS' style={{backgroundColor: '#11121a'}}>

        <NavBar/>
        <Padding/>
        <Padding/>
        <div className="container-text" style={{padding:"30px"}}>
            <h2>Database and LIMS</h2>



<div className="generic-column" style={{ width: '100%' }}>
    <h3>Data Architecture, LIMS & API Integration</h3>
    <p>
        Design and implementation of high-integrity data layers, bridging the gap between 
        legacy industrial hardware and modern enterprise environments.
    </p>

    <p>
        We have extensive expertise in architecting and maintaining the following core data technologies:
    </p>

    <div className="usp-list">
        <div className="usp-item">
            <strong>Oracle DB</strong>
            <span>
                As one of the most respected and robust database engines globally, this is the industry standard for 
                Pharmaceutical and Life Sciences applications. We provide high-performance management using PL/SQL 
                for complex stored procedures, ensuring absolute data integrity and regulatory compliance.
            </span>
        </div>

        <div className="usp-item">
            <strong>Microsoft SQL Server</strong>
            <span>
                Widely utilised across Automotive and General Manufacturing, this platform offers unparalleled 
                integration with the Windows ecosystem. We focus on comprehensive T-SQL development, bespoke 
                database architecture, and optimisation for high-speed industrial data logging.
            </span>
        </div>

        <div className="usp-item">
            <strong>Open Source Data</strong>
            <span>
                For scalable IoT logging and web-integrated platforms, we implement 
                high-performance MySQL environments, providing 
                robust and cost-effective data storage solutions.
            </span>
        </div>

        <div className="usp-item">
            <strong>Microsoft Azure & AWS</strong>
            <span>
                We specialise in deploying secure, scalable industrial cloud 
                infrastructure, utilising Azure IoT Hub and AWS IoT Core to provide 
                centralised telemetry, remote monitoring, and global data accessibility.
            </span>
        </div>

        <div className="usp-item">
            <strong>RESTful APIs</strong>
            <span>
                Modern data access requires more than just a database connection. We develop secure, scalable 
                Web APIs that act as a modern gateway, allowing industrial back-ends to communicate seamlessly 
                with cloud platforms, mobile dashboards, and third-party software suites.
            </span>
        </div>

        <div className="usp-item">
            <strong>gRPC</strong>
            <span>
                For environments requiring ultra-low latency, such as High-Speed Automation or Real-Time Analytics, 
                we implement this high-performance framework. Using Protocol Buffers allows for efficient, 
                typed communication across distributed microservices and cross-platform hardware.
            </span>
        </div>

        <div className="usp-item">
            <strong>Legacy Modernisation</strong>
            <span>
                Many industrial facilities rely on ageing software that is increasingly difficult to support. 
                We specialise in de-risking these environments by porting legacy logic into modern, maintainable 
                frameworks, extending the life of your assets while improving reliability.
            </span>
        </div>

        <div className="usp-item">
            <strong>Protocol Conversion</strong>
            <span>
                Integration often means making the "old" talk to the "new". We bridge the divide between older 
                serial or proprietary communication standards and modern Ethernet-based protocols, ensuring 
                your legacy sensors and PLCs are ready for Industry 4.0.
            </span>
        </div>
    </div>
</div>






        </div>

        <Padding/>
        <Padding/>

        <Sales/>
        <SEO/>
      </div>
  
      )
    }
  }

export default DatabaseLIMS;

